<template>
    <div>
        <div class="footer-wraper">
            <div class="footer-bottom">
                <div class="main">
                    <div class="btn-box">
                        <a :href="langContent.footer_global.info9" target="_blank">{{langContent.footer_global.info8}}</a>
                        <a :href="langContent.footer_global.info6" target="_blank">{{langContent.footer_global.info1}}</a>
                        <a :href="langContent.footer_global.info7" target="_blank">{{langContent.footer_global.info2}}</a>
                        <a @click="showContact">{{langContent.footer_global.info3}}</a>
                        <a href="https://global.ntfusion.com/#/about" target="_blank">{{langContent.footer_global.info4}}</a>
                    </div>

                    <img src="../../static/default/img/footer_logo.png" alt="" />

                    <p>{{langContent.footer_global.info5}}</p>
                </div>
            </div>
        </div>

        <div class="modal type2" :style="payAnswerShow?'':'display: none;'">
            <div class="modal-wrapper qa-modal" :style="payAnswerShow?'':'display: none;'">
                <a href="javascript:;" class="modal-btn-close-type2" role="button" @click="payAnswerShow = false">
                    <svg class="ov-icon" aria-hidden="true" width="19.2" height="19.2" viewBox="0.48 0.48 23.04 23.04"
                         fill="currentColor" style="font-size: 1.2em;">
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path d="M18.3 5.71a.996.996 0 00-1.41 0L12 10.59 7.11 5.7A.996.996 0 105.7 7.11L10.59 12 5.7 16.89a.996.996 0 101.41 1.41L12 13.41l4.89 4.89a.996.996 0 101.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"></path>
                    </svg>
                </a>
                <div class="modal-header">
                    <div class="title-wrap">
                        <h3 class="title">
                            {{langContent.login.info18}}
                        </h3>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="modal-content-wrap">
                        <ul class="ques-list">
                            <li @click="selectPayAnswerNumber(1)" class="item" :class="payAnswerNumber==1?'active':''">
                                <div class="title-wrap">
                                    <div class="title">
                                        {{langContent.login.info19}}
                                    </div>
                                    <div class="op-wrap">
                                        <a class="btn" href="javascript:;" role="button">
                                            <svg class="ov-icon" aria-hidden="true" width="19.2" height="19.2" viewBox="0.48 0.48 23.04 23.04"
                                                 fill="currentColor" style="font-size: 1.2em;">
                                                <path d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div class="detail-wrap">
                                    {{langContent.login.info20}}
                                </div>
                            </li>
                            <li @click="selectPayAnswerNumber(2)" class="item" :class="payAnswerNumber==2?'active':''">
                                <div class="title-wrap">
                                    <div class="title">
                                        {{langContent.login.info21}}
                                    </div>
                                    <div class="op-wrap">
                                        <a class="btn" href="javascript:;" role="button">
                                            <svg class="ov-icon" aria-hidden="true" width="19.2" height="19.2" viewBox="0.48 0.48 23.04 23.04"
                                                 fill="currentColor" style="font-size: 1.2em;">
                                                <path d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div class="detail-wrap">
                                    {{langContent.login.info22}}
                                </div>
                            </li>
                            <li @click="selectPayAnswerNumber(3)" class="item" :class="payAnswerNumber==3?'active':''">
                                <div class="title-wrap">
                                    <div class="title">
                                        {{langContent.login.info23}}
                                    </div>
                                    <div class="op-wrap">
                                        <a class="btn" href="javascript:;" role="button">
                                            <svg class="ov-icon" aria-hidden="true" width="19.2" height="19.2" viewBox="0.48 0.48 23.04 23.04"
                                                 fill="currentColor" style="font-size: 1.2em;">
                                                <path d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div class="detail-wrap">
                                    {{langContent.login.info24}}
                                </div>
                            </li>
                            <li @click="selectPayAnswerNumber(4)" class="item" :class="payAnswerNumber==4?'active':''">
                                <div class="title-wrap">
                                    <div class="title">
                                        {{langContent.login.info25}}
                                    </div>
                                    <div class="op-wrap">
                                        <a class="btn" href="javascript:;" role="button">
                                            <svg class="ov-icon" aria-hidden="true" width="19.2" height="19.2" viewBox="0.48 0.48 23.04 23.04"
                                                 fill="currentColor" style="font-size: 1.2em;">
                                                <path d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div class="detail-wrap">
                                    {{langContent.login.info26}}
                                </div>
                            </li>
                            <li @click="selectPayAnswerNumber(5)" class="item" :class="payAnswerNumber==5?'active':''">
                                <div class="title-wrap">
                                    <div class="title">
                                        {{langContent.login.info27}}
                                    </div>
                                    <div class="op-wrap">
                                        <a class="btn" href="javascript:;" role="button">
                                            <svg class="ov-icon" aria-hidden="true" width="19.2" height="19.2" viewBox="0.48 0.48 23.04 23.04"
                                                 fill="currentColor" style="font-size: 1.2em;">
                                                <path d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div class="detail-wrap">
                                    {{langContent.login.info28}}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // import langCn from '../data/lang_cn'
    import langCn from '../data/lang_cn_sea'
    import langHant from '../data/lang_hant_sea'
    import langEn from '../data/lang_en_sea'
    import Utils from '../lib/utils'

    export default {
        data () {
            return {
                langContent: langCn,
                contents: '',
                payAnswerShow: false,
                payAnswerNumber: 5,
                langVal: 'cn'
            }
        },
        mounted() {
            setTimeout(() => {
                let self = this;
                let lang = Utils.getCookie('lang')?Utils.getCookie('lang'):'';
                self.langVal = lang;

                if (lang == 'hant') {
                    self.langContent = langHant;
                } else if (lang == 'cn') {
                    self.langContent = langCn;
                } else if (lang == 'en') {
                    self.langContent = langEn;
                }
            },1000)

        },
        methods: {
            selectPayAnswerNumber(index) {
                if (this.payAnswerNumber == index) {
                    this.payAnswerNumber = '';
                } else {
                    this.payAnswerNumber = index;
                }
            },

            showContact() {
                this.payAnswerShow = true;
                this.payAnswerNumber = 5;
            }
        }
    }
</script>
<style lang="less">
    .footer-wraper .footer-bottom {
        background-color: #2d2f46;
        height: 2rem;
        /*position: fixed;*/
        /*width: 100%;*/
        /*bottom: 0;*/
        position: relative;
    }

    .footer-wraper .footer-bottom .main {
        align-items: center;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 2rem;
        justify-content: center;
        margin: 0 auto
    }

    .footer-wraper .footer-bottom .main p {
        color: #f4f4f4;
        font-size: .16rem;
        line-height: .32rem;
        padding-top: .2rem;
        text-align: center
    }

    .footer-wraper .footer-bottom .main img {
        display: block
    }

    .footer-wraper .footer-bottom .main .btn-box {
        display: flex;
        font-size: 16px;
        margin:20px 0;
    }

    .footer-wraper .footer-bottom .main .btn-box a {
        color: #FCA557;
        margin: 0 10px;
        text-decoration: underline;
        cursor: pointer;
    }

    /* PC端样式 */
    @media only screen and (min-width: 768px) {
        .modal {
            position: fixed;
            top: 0;
            left: 0;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: 50px 0 100px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            background-color: rgba(0,0,0,.8);
            z-index: 10000;
            overscroll-behavior: contain;
            -ms-scroll-chaining: contain;
            overflow: auto
        }

        .modal-wrapper {
            position: relative;
            font-size: 0;
            z-index: 10001;
            margin: auto
        }

        .modal-type2 {
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
            background: #fff;
            border-radius: 24px;
            width: 560px;
            position: absolute
        }

        .modal-type2 .modal-btn-close {
            position: absolute;
            top: 20px;
            right: 20px
        }

        .modal-btn-close {
            display: block;
            width: 28px;
            height: 28px;
            z-index: 1;
            position: relative
        }

        .modal-btn-close:before,.modal-btn-close:after {
            content: "";
            width: 4px;
            height: 100%;
            border-radius: 10px;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -2px;
            background: #000
        }

        .modal-btn-close:before {
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg)
        }

        .modal-btn-close:after {
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg)
        }

        .modal-btn-close.type2:before,.modal-btn-close.type2:after {
            background: #fff
        }

        .modal-type2 .modal-header {
            padding: 40px 40px 0;
            position: relative
        }

        .modal-type2 .modal-header .title {
            font-size: 32px;
            text-align: center;
            font-weight: 500
        }

        .modal-type2 .modal-body {
            padding: 40px
        }

        .modal.type2 {
            padding: 0;
            -webkit-box-pack: end;
            -webkit-justify-content: flex-end;
            -ms-flex-pack: end;
            justify-content: flex-end
        }

        .qa-modal {
            width: 638px;
            height: 450px;
            border-radius: 20px;
            margin: auto;
            min-height: 50vh;
            max-height: 100%;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            background-color: #fff;
        }

        .qa-modal .modal-btn-close-type2 {
            top: 10px;
            right: 20px;
            color: #333
        }

        .qa-modal .modal-header {
            padding: 32px
        }

        .qa-modal .modal-header .title-wrap {
            text-align: center
        }

        .qa-modal .modal-header .title-wrap .title {
            font-size: 22px;
            color: #000;
            font-weight: 700
        }

        .qa-modal .modal-body {
            padding: 0 46px 56px 56px;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            overflow: hidden
        }

        .qa-modal .modal-body .modal-content-wrap {
            padding-right: 10px;
            height: 100%;
            overflow: auto
        }

        .qa-modal .modal-body .modal-content-wrap::-webkit-scrollbar {
            width: 8px;
            height: 8px
        }

        .qa-modal .modal-body .modal-content-wrap::-webkit-scrollbar-thumb {
            border-radius: 8px;
            background-color: #707070
        }

        .qa-modal .ques-list>.item .title-wrap {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            height: 38px
        }

        .qa-modal .ques-list>.item .title-wrap>.title {
            font-size: 18px;
            color: #333;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1
        }

        .qa-modal .ques-list>.item .title-wrap .op-wrap .btn {
            color: gray;
            width: 40px;
            height: 40px;
            display: block
        }

        .qa-modal .ques-list>.item .title-wrap .op-wrap .btn .ov-icon {
            width: 100%;
            height: 100%
        }

        .qa-modal .ques-list>.item .detail-wrap {
            padding: 24px;
            border-radius: 20px;
            background-color: #f6f7fe;
            font-size: 14px;
            color: #707070;
            line-height: 1.7;
            display: none
        }

        .qa-modal .ques-list>.item .detail-wrap>i {
            font-weight: 700;
            color: #606de2
        }

        .qa-modal .ques-list>.item .detail-wrap>a {
            color: #606de2;
            text-decoration: underline
        }

        .qa-modal .ques-list>.item+.item {
            margin-top: 20px
        }

        .qa-modal .ques-list>.item.active .title-wrap .op-wrap .btn {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg)
        }

        .qa-modal .ques-list>.item.active .detail-wrap {
            display: block
        }

        .modal-btn-close-type2 {
            display: block;
            width: 40px;
            height: 40px;
            z-index: 1;
            position: absolute;
            color: #fff
        }

        .modal-btn-close-type2 .ov-icon {
            width: 100%;
            height: 100%
        }

        .user-info a {
            color: blue;
            text-decoration: underline;
            cursor: pointer;
        }
    }

    /* 移动端样式 */
    @media only screen and (max-width: 767px) {
        .qa-modal {
            margin: 0;
            width: 100%;
            min-height: 50vh;
            max-height: 100%;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            background-color: #fff;
            border-radius: .2rem .2rem 0 0
        }

        .modal-wrapper {
            position: relative;
            font-size: 0;
            z-index: 10001;
            /*margin: auto*/
        }

        .modal-type2 {
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
            background: #fff;
            border-radius: .24rem;
            width: 5.6rem;
            position: absolute
        }

        .modal-type2 .modal-btn-close {
            position: absolute;
            top: .2rem;
            right: .2rem
        }

        .modal-btn-close {
            display: block;
            width: .42rem;
            height: .42rem;
            z-index: 1;
            position: relative
        }

        .modal-btn-close:before,.modal-btn-close:after {
            content: "";
            width: .04rem;
            height: 100%;
            border-radius: .1rem;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -.02rem;
            background: #000
        }

        .modal-btn-close:before {
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg)
        }

        .modal-btn-close:after {
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg)
        }

        .modal-btn-close.type2:before,.modal-btn-close.type2:after {
            background: #fff
        }

        .modal-type2 .modal-header {
            padding: .4rem .4rem 0;
            position: relative
        }

        .modal-type2 .modal-header .title {
            font-size: .32rem;
            text-align: center;
            font-weight: 500
        }

        .modal-type2 .modal-body {
            padding: .4rem
        }

        .modal-type2 .modal-footer .op-wrap {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            border-top: 1px solid #ebeef5
        }

        .modal-type2 .modal-footer .op-wrap .btn {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            height: .92rem;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -ms-flex-pack: center;
            justify-content: center;
            font-size: .28rem;
            color: #606de2
        }

        .modal-type2 .modal-footer .op-wrap .btn+.btn {
            border-left: .02rem solid #ebeef5
        }

        .modal-type2 .modal-footer .op-wrap2 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -ms-flex-pack: center;
            justify-content: center;
            padding-bottom: .4rem
        }

        .modal-type2 .modal-footer .op-wrap2 .btn {
            height: .6rem;
            border-radius: .6rem;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -ms-flex-pack: center;
            justify-content: center;
            font-size: .28rem;
            min-width: 2rem;
            -webkit-box-sizing: border-box;
            box-sizing: border-box
        }

        .modal-type2 .modal-footer .op-wrap2 .btn.type-primary {
            color: #fff;
            background-color: #606de2
        }

        .modal-type2 .modal-footer .op-wrap2 .btn.type-default {
            color: #606266;
            border: 1px solid #dcdfe6
        }

        .modal-type2 .modal-footer .op-wrap2 .btn+.btn {
            margin-left: .3rem
        }

        .qa-modal .modal-btn-close-type2 {
            top: .1rem;
            right: .2rem;
            color: #333
        }

        .qa-modal .modal-header {
            padding: .32rem
        }

        .qa-modal .modal-header .title-wrap {
            text-align: center
        }

        .qa-modal .modal-header .title-wrap .title {
            font-size: .32rem;
            color: #000;
            font-weight: 500
        }

        .qa-modal .modal-body {
            padding: 0 .46rem .56rem .56rem;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            overflow: hidden
        }

        .qa-modal .modal-body .modal-content-wrap {
            padding-right: .1rem;
            height: 100%;
            overflow: auto
        }

        .qa-modal .modal-body .modal-content-wrap::-webkit-scrollbar {
            width: .08rem;
            height: .08rem
        }

        .qa-modal .modal-body .modal-content-wrap::-webkit-scrollbar-thumb {
            border-radius: .08rem;
            background-color: #707070
        }

        .qa-modal .ques-list>.item .title-wrap {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            height: .58rem
        }

        .qa-modal .ques-list>.item .title-wrap>.title {
            font-size: .26rem;
            color: #333;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1
        }

        .qa-modal .ques-list>.item .title-wrap .op-wrap .btn {
            color: gray;
            width: .5rem;
            height: .5rem;
            display: block
        }

        .qa-modal .ques-list>.item .title-wrap .op-wrap .btn .ov-icon {
            width: 100%;
            height: 100%
        }

        .qa-modal .ques-list>.item .detail-wrap {
            padding: .24rem;
            border-radius: .2rem;
            background-color: #f6f7fe;
            font-size: .2rem;
            color: #707070;
            line-height: 1.7;
            display: none
        }

        .qa-modal .ques-list>.item .detail-wrap>i {
            font-weight: 700;
            color: #606de2
        }

        .qa-modal .ques-list>.item .detail-wrap>a {
            color: #606de2;
            text-decoration: underline
        }

        .qa-modal .ques-list>.item+.item {
            margin-top: .14rem
        }

        .qa-modal .ques-list>.item.active .title-wrap .op-wrap .btn {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg)
        }

        .qa-modal .ques-list>.item.active .detail-wrap {
            display: block
        }

        @media screen and (min-width: 821px) {
            .qa-modal {
                width:6.38rem;
                height: 4.5rem;
                border-radius: .2rem;
                margin: auto
            }

            .qa-modal .modal-header .title-wrap .title {
                font-size: .22rem;
                font-weight: 700
            }

            .qa-modal .ques-list>.item .title-wrap {
                height: .38rem
            }

            .qa-modal .ques-list>.item .title-wrap>.title {
                font-size: .18rem
            }

            .qa-modal .ques-list>.item .title-wrap .op-wrap .btn {
                width: .4rem;
                height: .4rem
            }

            .qa-modal .ques-list>.item .detail-wrap {
                font-size: .14rem
            }

            .qa-modal .ques-list>.item+.item {
                margin-top: .2rem
            }
        }

        .modal {
            position: fixed;
            top: 0;
            left: 0;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: .5rem 0 1rem;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            background-color: rgba(0,0,0,.8);
            z-index: 10000;
            overscroll-behavior: contain;
            -ms-scroll-chaining: contain;
            overflow: auto
        }

        .modal.type2 {
            padding: 0;
            -webkit-box-pack: end;
            -webkit-justify-content: flex-end;
            -ms-flex-pack: end;
            justify-content: flex-end
        }

        .modal-btn-close-type2 {
            display: block;
            width: .6rem;
            height: .6rem;
            z-index: 1;
            position: absolute;
            color: #fff
        }

        .modal-btn-close-type2 .ov-icon {
            width: 100%;
            height: 100%
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/footer_global.vue